module.exports = __webpack_public_path__ + "img/stakebody_parked.a2c1ec9d.svg";